import React, { useEffect } from 'react';
import { Layout, Breadcrumb, Empty, Button } from 'antd';
import * as S from './Complexes.styled';
import {
	IsAcceptedSelector,
	IsManagerSelector,
	IsOwnerSelector,
	UserSelector,
} from 'features/User/UserSlice';
import Meta from 'components/Meta';
import { useSelector } from 'react-redux';
import ComplexesList from 'features/ComplexesList';
import { openCreateComplexModal } from 'features/CreateComplexModal/CreateComplexModalSlice';
import { useAppDispatch } from 'hooks/useStore';
import { fetchComplexes } from 'features/ComplexesList/ComplexesListSlice';
import { fetchOrganizations } from 'features/OrganizationsList/OrganizationsListSlice';

const { Content } = Layout;

const Complexes = (): JSX.Element => {
	const dispatch = useAppDispatch();

	// Подтвержденность пользователя
	const isAccepted = useSelector(IsAcceptedSelector);
	const isOwner = useSelector(IsOwnerSelector);
	const isManager = useSelector(IsManagerSelector);

	useEffect(() => {
		if (isOwner || (isAccepted && isManager)) dispatch(fetchOrganizations());
		if (isOwner || (isAccepted && isManager)) dispatch(fetchComplexes());
	}, [dispatch, isAccepted, isManager, isOwner]);

	const { organizationId } = useSelector(UserSelector);

	const onOpenCreateComplexModal = () =>
		dispatch(openCreateComplexModal(isOwner ? null : organizationId));

	return (
		<Content
			style={{
				padding: '0px 20px 20px 20px',
				display: 'flex',
				flexDirection: 'column',
			}}>
			<Meta pageName="requests" />
			<Breadcrumb
				items={[{ title: 'realty platform' }, { title: 'living complexes' }]}
				style={{ margin: '16px 0' }}
			/>
			<S.WorkSpace>
				{isOwner || (isAccepted && isManager) ? (
					<>
						<S.Header>
							<Button
								type="primary"
								size="large"
								block
								disabled={!isOwner}
								onClick={onOpenCreateComplexModal}>
								Add complex
							</Button>
						</S.Header>
						<ComplexesList />
					</>
				) : (
					<S.Empty>
						<Empty
							image={Empty.PRESENTED_IMAGE_SIMPLE}
							description="You do not have the necessary rights to view this section"
						/>
					</S.Empty>
				)}
			</S.WorkSpace>
		</Content>
	);
};

export default Complexes;
